"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePonyfill;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePonyfill() {
  return (0, _useContext.default)().ponyfillState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VQb255ZmlsbCIsInVzZVBvbnlmaWxsQ29udGV4dCIsInBvbnlmaWxsU3RhdGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm92aWRlcnMvUG9ueWZpbGwvdXNlUG9ueWZpbGwudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVBvbnlmaWxsQ29udGV4dCBmcm9tICcuL3ByaXZhdGUvdXNlQ29udGV4dCc7XG5cbmltcG9ydCB0eXBlIHsgR2xvYmFsU2NvcGVQb255ZmlsbCB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VQb255ZmlsbCgpOiByZWFkb25seSBbR2xvYmFsU2NvcGVQb255ZmlsbF0ge1xuICByZXR1cm4gdXNlUG9ueWZpbGxDb250ZXh0KCkucG9ueWZpbGxTdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSWUsU0FBU0EsV0FBVCxHQUF1RDtFQUNwRSxPQUFPLElBQUFDLG1CQUFBLElBQXFCQyxhQUE1QjtBQUNEIn0=